export const PHYSICIAN_ROLE = 'MEDICO'
export const SPECIALIST_ROLE = 'ESPECIALISTA'
export const SPECIALIST_TASKFORCE_ROLE = 'ESPECIALISTA_MUTIRAO'
export const SUPPORT_TASKFORCE_ROLE = 'SUPORTE_MUTIRAO'
export const CT = 'CT'
export const CLINIC = 'CLINICA'
export const ADMIN_TASKFORCE = 'ADMIN_MUTIRAO'
